<template>
  <div>
    <PageTitle
      :title="$t('batteries.add')"
      :description="$t('batteries.descriptionType')"
    ></PageTitle>
    <div class="row u-justify-content-center">
      <div
        class="es-xs-6 es-md-4 es-lg-3 u-margin-top"
        v-for="(type, i) in batteryTypes"
        :key="i"
      >
        <div class="u-text-align-center">
          <div>
            <img
              :src="require(`@/assets/images/battery-types/${type.key}.png`)"
              width="150"
              :alt="type.name"
            />
          </div>
          <div class="u-font-size-small u-color-muted u-text-align-center">
            <i>{{
              $t("batteries.chooseBatteryText", { type: $t(type.name) })
            }}</i>
          </div>
          <div class="u-margin-top-small">
            <Button
              :disabled="!hasAuthorize[type.key]"
              variant="primary"
              @click="SET_BATTERY_TYPE(type)"
            >
              {{ $t("common.choose") }} <i class="icofont-arrow-right"></i>
            </Button>
          </div>
          <div class="u-margin-top-small" v-if="!hasAuthorize[type.key]">
            <small class="u-color-warning">
              <i class="icofont-warning"></i>
              {{ $t("common.noAuthorize") }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/components/Shared/PageTitle/index.vue";
import { getBatteryTypes } from "@/helpers/Battery/getBatteryType";
import Button from "@/components/Base/Button.vue";
export default {
  components: {
    PageTitle,
    Button,
  },
  data() {
    return {
      batteryTypes: getBatteryTypes(),
    };
  },
  computed: {
    hasAuthorize() {
      const list = this.$store.getters["getAuthorizeList"];
      const activeUser = this.$store.getters["getActiveUser"];

      if (activeUser.userInfo.role === "Admin")
        return {
          Evaporator: true,
          Condenser: true,
        };
      return {
        Evaporator: !list.some(
          (item) => item.authorityInfo.action === "CalculateEvaporatorBattery"
        ),
        Condenser: !list.some(
          (item) => item.authorityInfo.action === "CalculateCondenserBattery"
        ),
      };
    },
  },
  methods: {
    SET_BATTERY_TYPE(type) {
      this.$router.push({ query: { type: type.key } });
      this.$emit("set:batteryType", type.key);
    },
  },
};
</script>

<style></style>
